import axios from "axios";
import { ServerSideTypes } from "../../common/OperationCommonTypes";
import { DamageTypes } from "../Types";
import OperationTypes from "../../../types";
import { CreateDamageFormTypes } from "../../damageFormList/Types";

const DamagePriceService ={
   get:{
      
      getallSeverity:()=>{
         return axios.get('./masterdatadamage/severity').then(response => response.data)
      },
      allPart:(tenantValue:string)=>{
         return   axios.get("masterdatadamage/partposition/bytenant",{ params:{tenant: tenantValue} }
            ).then(response =>response.data) 

      },
      getAllDamage:(tenants:string,data:DamageTypes.FilterDamageRequest,serverParams: ServerSideTypes.IParams)=>{
         let formCode = data.formCode;
         let partId =data.part?.split("-")[0];
         let positionId = data.part?.split("-")[1];
         let plate = data.plate;
         let open  =data.open;
         let severity = data.severity;
         let vin = data.vin;
         return axios.get('./masterdatadamage/damage/pageddamages',{params:{tenants,formCode,plate,vin,partId,positionId,severity,open,...serverParams}}).then(response =>response.data)
      },
      getExportExcel:(tenants:string,data:DamageTypes.FilterDamageRequest)=>{
         let formCode = data.formCode;
         let partId =data.part?.split("-")[0];
         let positionId = data.part?.split("-")[1];
         let plate = data.label;
         let open  =data.open;
         let severity = data.severity;
         let vin = data.vin;
         return axios.get('./masterdatadamage/damage/exportexcel',{params:{tenants,formCode,plate,vin,partId,positionId,severity,open},responseType:"arraybuffer"})
      },
      getDamagePriceListDetails:(tenant:string,idDamage:number)=>{
      return axios.get("./masterdatadamage/damage/details",{params:{tenant:tenant,idDamage:idDamage}}).then(response =>response.data)
      },
      getAllDamagesByFormId:(tenant:string,formId:number)=>{
         return axios.get<OperationTypes.Damage[]>("./masterdatadamage/damage/allbyformid",{params:{tenant:tenant,formId:formId}}).then(
            response => response.data
         )
      },
      formByCode: (tenant: string, formCode: string) => {
         return axios.get<DamageTypes.FormByCode>("/masterdatadamage/damageform/formbycode", { params: { formCode, tenant }}).then(
             (response) => {
                 return response.data
             }
         )
      },
      existingDamages: (tenant: string, plate?: string) => {
         if (!plate) return Promise.resolve([]);

         return axios.get<OperationTypes.Damage[]>("/masterdatadamage/damage/getopen", {params: { tenant, plate }}).then(
             response => response.data,
         )
     },
   },
   put: {
      closeDamage:(tenant:string,idDamage:number)=>{
         return axios.put("./masterdatadamage/damage/close?tenant="+tenant+"&idDamages="+idDamage).then(response =>response.data)
      },
      assignDamage: (tenant: string, fromSC: boolean | undefined, data: CreateDamageFormTypes.IReqAssignDamage[]) => {
        return axios.put("/masterdatadamage/damageform/assigndamages", data, { params: {tenant, fromSC}}).then(
            response => response.data                    
        )
    },
	reopenDamage:(tenant:string,idDamage:number)=>{
        return axios.put("./masterdatadamage/damage/reopen?tenant="+tenant+"&idDamages="+idDamage).then(response =>response.data)
     },
   },
   post: {
      addOpen: (tenant: string, data: CreateDamageFormTypes.IReqCreateDamage) => {
         return axios.post<CreateDamageFormTypes.IRespCreateDamage[]>("/masterdatadamage/damage/addopen", data, { params: {tenant}}).then(
             response => response.data,
         )
     },
     addPhoto: (damageId: number, snapshots: (File | null)[]) => {
         const data = new FormData();
         if (snapshots[0]) {
             data.append("snapshots", snapshots[0]);
         }
         if (snapshots[1]){
             data.append("snapshots", snapshots[1]);
         }

         return axios.post("/masterdatadamage/snapshot/add", data, {
             params: {
                 damageId,
                 damageIsOpen: true,
             },
             headers: { "Content-Type": "multipart/form-data" },
         }).then(
             response => response.data,
         )
     },
   },
   delete: {
      damage: (damageId : number) => {
         return axios.delete(`/masterdatadamage/damage/deleteopen/${damageId}`)
     },
     attachment: (tenant: string, idAttachment: string, type: string | undefined) => {
      return axios.delete("/masterdatadamage/attachments/deleteattachment", {
          params: { tenant, idAttachment, type }
      });
  },
   }
}
export default DamagePriceService;